import { Injectable, inject } from '@angular/core';
import { Store } from '@ngrx/store';
import { Observable } from 'rxjs';

import { AppState } from '../app.state';

import { SavedLocation } from './location.state';
import {
  selectLocation,
  selectLocationDisplayText,
  selectHasLocation,
  selectRegionId,
} from './location.selectors';
import * as LocationActions from './location.actions';

@Injectable({
  providedIn: 'root',
})
export class LocationFacade {
  private store = inject(Store<AppState>);

  location$ = this.store.select(selectLocation);
  locationDisplayText$ = this.store.select(selectLocationDisplayText);
  hasLocation$ = this.store.select(selectHasLocation);
  regionId$ = this.store.select(selectRegionId);

  getRegionId(): Observable<string> {
    return this.store.select(selectRegionId);
  }

  setLocation(location: SavedLocation): void {
    this.store.dispatch(LocationActions.setLocation({ location }));
  }

  setRegionId(regionId: string): void {
    this.store.dispatch(LocationActions.setRegionId({ regionId }));
  }

  clearLocation(): void {
    this.store.dispatch(LocationActions.clearLocation());
  }

  loadLocationFromStorage(): void {
    this.store.dispatch(LocationActions.loadLocationFromStorage());
  }
}
